<script>
  import Swal from 'sweetalert2';
  import validateEmail from '../utils/validateEmail';

  import { showQuoteForm } from '../stores/ShowQuoteForm';
  import { subscriberEmail } from '../stores/SubscriberEmail.js';

  import Button from './Button.svelte';
  import LinkItem from './LinkItem.svelte';
  import Footer from '../components/LandingPage/Footer.svelte';

  let subscribedTick = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 32 32">
<path fill="currentColor" d="M28.8,6.4L30,4.3c0.4-0.7,0.4-1.6,0-2.3c-0.4-0.7-1.2-1.2-2-1.2l0,0c-0.8,0-1.6,0.5-2,1.2l-0.7,1c-2.6-1.9-5.9-3-9.3-3
	C7.2,0,0,7.2,0,16s7.2,16,16,16s16-7.2,16-16C32,12.4,30.8,9,28.8,6.4z M16,29.5C8.5,29.5,2.5,23.4,2.5,16C2.5,8.5,8.5,2.4,16,2.4
	c3,0,5.8,1,8,2.7l-8.7,13.6L9.5,13c-0.7-1-2.3-1.2-3.3-0.4S5.2,15,6,16l7.9,9.7c0.9,1.1,3,1,3.8-0.3l9.8-16.6
	c1.4,2.1,2.1,4.6,2.1,7.3C29.5,23.4,23.5,29.5,16,29.5z"/>
</svg>`;

  function quoteRequest() {
    $showQuoteForm = true;
  }

  const info = [
    { name: 'About Us', slug: 'about' },
    // { name: "How it works?", slug: "how-to-design" },
    { name: 'Privacy Policy', slug: 'privacy-policy' },
    { name: 'Returns Policy', slug: 'returns-policy' },
    { name: 'Terms', slug: 'terms-conditions' },
    // { name: "Order and Return", slug: "order-and-return" },
    { name: 'Contact Us', slug: 'contact' },
    // { name: "Read our Blog", slug: "blog" },
  ];

  const usefulLinks = [
    // { name: "Categories", slug: "categories" },
    { name: 'Product List', slug: 'products' },
    { name: 'Design Now', slug: 'products' },
    { name: 'Events', slug: 'events' },
    // { name: "Blog Article", slug: "blogs" },
    { name: 'Work wear', slug: 'work' },
    { name: 'Sportswear', slug: 'sports' },
  ];

  const design = [
    { name: 'Design online', slug: 'products' },
    { name: 'Request a Quote', slug: 'quote-request', clickFn: quoteRequest },
    // { name: "How to Design", slug: "how-to-design" },
    // { name: "Printing Styles", slug: "printing-styles" },
    // { name: "Sports & Games", slug: "sports-games" },
    //TODO - add a decal page
  ];

  let emailSignupAddress = $subscriberEmail;
  // let triggerAcFormSubmit = false;
  // function submitACForm() {
  //   triggerAcFormSubmit = true;
  // }

  async function signup() {
    // Validate email address and then run the submit function for the form
    if (emailSignupAddress?.length > 0) {
      if (validateEmail(emailSignupAddress)) {
        //submitACForm();
        $subscriberEmail = emailSignupAddress;
        // TODO - save email to DB and generate a UID to send to analytics
      } else {
        Swal.fire('Invalid Email Address', 'Please enter a valid email address', 'error');
      }
    }

    // const signupQuery = gql`
    //   query MyQuery($email: String!) {
    //     emailSignUp(email: $email) {
    //       status
    //     }
    //   }
    // `;

    // let res = await client.query({
    //   query: signupQuery,
    //   variables: {
    //     email: emailSignupAddress,
    //   },
    // });
    // let status = res?.data?.emailSignUp?.status;
    // //console.log("status: ", status);
    // //if siged up then show tick
    // if (status === "success") {
    //   $subscriberEmail = emailSignupAddress;
    // }
  }
</script>

<div class="footer">
  <div class="top">
    <div class="links">
      <div class="address">
        <h5>Contact</h5>
        <div class="address__physical">
          <div class="">Address:<br />3/9 Link Cr, Coolum QLD 4573</div>
          <div class="">
            Phone:
            <a href="tel:1300011270">1300 011 270</a>
          </div>
          <div class="">We are open: Monday-Friday: 8:00 AM - 5:30 PM</div>
        </div>
      </div>
      <LinkItem label="Company Info" links={info} />
      <LinkItem label="Useful links" links={usefulLinks} />
      <LinkItem label="Design" links={design} />
    </div>
    <div class="newsletter">
      <h1>Sign Up To Our Newsletter.</h1>
      <span>Be the first to hear about the latest offers.</span>
      <div class="newsletter__form">
        <input
          type="email"
          name="email"
          placeholder="Email Address"
          id=""
          bind:value={emailSignupAddress}
          disabled={$subscriberEmail}
        />
        {#if !$subscriberEmail}}
          <Button label="Subscribe" clickFn={signup} />
        {:else}
          <div class="subscribed">{@html subscribedTick}</div>
        {/if}
      </div>
    </div>
  </div>
  <Footer />
</div>

<style>
  input {
    padding: 1.2rem;
    font-size: 1.5rem;
    border: 2px solid #fff;
    background-color: transparent;
    width: 100%;
    margin-right: 1rem;
    font-family: 'Oswald', sans-serif;
    font-weight: 500;
    color: #fff;
    text-transform: uppercase;
  }

  .footer {
    margin-top: auto; /* Sticky Footer - https://dev.to/nehalahmadkhan/how-to-make-footer-stick-to-bottom-of-web-page-3i14*/
    background: linear-gradient(2deg, #1c2a5c, #081544);
    overflow: auto;
  }

  .top {
    margin: 2rem;
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-between;
  }

  .top h5 {
    font-weight: 700;
    color: #848484;
    font-size: 1.4rem;
    margin-bottom: 3rem;
  }
  .address a {
    text-decoration: none;
    color: #fe5900;
    font-size: 1.3rem;
  }

  .address__physical {
    line-height: 2;
    color: #fff;
    font-size: 1.3rem;
    width: 100%;
  }

  .links {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 2rem;
    margin: 4rem 0 0 0;
  }

  .newsletter {
    width: 100%;
    max-width: 100%;
  }

  .newsletter h1 {
    font-size: 2rem;
    font-family: 'Oswald', sans-serif;
    font-weight: 500;
    color: #fff;
    line-height: 1;
  }

  .newsletter span {
    margin: 2rem 0;
    display: block;
    color: #fff;
    font-weight: 300;
    font-size: 1.6rem;
    font-family: 'Inter', sans-serif;
  }

  .newsletter__form {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .newsletter__form input {
    margin-bottom: 2rem;
  }

  .subscribed {
    color: #fe5900;
    width: 60px;
  }

  @media screen and (min-width: 360px) {
    .top {
      margin: 4rem;
    }

    .newsletter h1 {
      font-size: 2.6rem;
    }
  }
  @media screen and (min-width: 360px) {
    .links {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  @media screen and (min-width: 500px) {
    .newsletter__form {
      flex-direction: row;
      justify-content: space-between;
    }

    .newsletter__form input {
      margin-bottom: 0;
    }

    .subscribed {
      width: 80px;
      margin-right: 4rem;
    }
  }

  @media screen and (min-width: 600px) {
    .top {
      margin: 4rem;
    }

    .links {
      grid-template-columns: repeat(4, 1fr);
    }
  }
  @media screen and (min-width: 800px) {
    .top {
      margin: 8rem 12rem;
      flex-direction: row;
      width: auto;
    }

    .newsletter {
      max-width: 50rem;
    }

    .links {
      margin: 0 2rem;
    }
  }

  @media screen and (min-width: 1300px) {
    .top {
      margin: 8rem auto;
      width: 140rem;
      flex-direction: row;
    }

    .newsletter h1 {
      font-size: 3.8rem;
    }

    .links {
      margin: 0 4rem;
    }

    .newsletter {
      width: 90rem;
    }
  }

  @media print {
    .footer {
      display: none;
    }
  }
</style>
